import React, { Component } from "react"
import { connect } from "react-redux"
import { compose } from "redux"
import PropTypes from "prop-types"
import { translate } from "react-i18next"
import JourneyQuestionShape from "../../state/shapes/JourneyQuestionShape"
import Widget from "../layout/widget/Widget"
import ColumnLineChart from "../charts/generic/ColumnLineChart"
import GroupedSelectList from "../inputs/GroupedSelectList"
import styled from "styled-components"

const DropdownArea = styled.div`
  margin-left: 2em;
  margin-right: 2em;
`

class Journeys extends Component {
  constructor(props) {
    super(props)

    this.state = {
      barChartData: this.getBarChartData(this.props.data.summaries[0]),
      extraExportParameter: `&questionReference=${this.props.data.summaries[0].questionReference}&questionTextTranslationKeyIdentifier=${this.props.data.summaries[0].questionTextTranslationKeyIdentifier}`
    }
  }

  onSelectChange = e => {
    const questionReference = e.target.value
    const questionSummary = this.getQuestionData(questionReference)

    this.setState({
      barChartData: this.getBarChartData(questionSummary),
      extraExportParameter: `&questionReference=${questionReference}&questionTextTranslationKeyIdentifier=${questionSummary.questionTextTranslationKeyIdentifier}`
    });
  }

  getGroupedQuestionsFromApi = () => {
    return this.props.data.groupedQuestions
  }

  getQuestionData = selectedQuestionReference => {
    return this.props.data.summaries.find(summary => summary.questionReference === selectedQuestionReference)
  }  

  getBarChartData = questionSummary => {
    const barChartData = {
      categories: [],
      series: [{
        showInLegend: false,
        type: "column",
        name: this.props.t("Common.Responses"),
        data: []
      }]
    }

    questionSummary.answerSummaries.forEach(a => {
      // Add categories
      if (!barChartData.categories.includes(a.answerValue)) {
        barChartData.categories.push(a.answerValue)
      }

      // Add column series
      barChartData.series[0].data.push(a.answerCount)
    })

    return barChartData
  }

  render() {
    const { t, exportEndpoint, appliedFilters } = this.props
    const titleKey="Widgets.Journeys.Title"
    return (
      <Widget
        columns={2}
        titleKey={titleKey}
        helpKey="Widgets.Journeys.Help"
        exportEndpoint={exportEndpoint}
        appliedFilters={appliedFilters}
        exportParams={this.state.extraExportParameter}
      >
        <div className="col-lg-12 col-md-12">
          <DropdownArea className="form-group">
            <GroupedSelectList onSelectChange={this.onSelectChange} data={this.getGroupedQuestionsFromApi()} />
          </DropdownArea>
          <div className="row">
            <div className="col-lg-12 col-md-12">
              <ColumnLineChart
                data={this.state.barChartData}
                yAxisTitle={t("Common.Responses")}
                yLineAxisTitle={t("Common.Average")}
                xAxisTitle={t("Common.Value")}
                titleKey={titleKey}
              />
            </div>
          </div>
        </div>
      </Widget>
    )
  }
}

Journeys.propTypes = {
  appliedFilters: PropTypes.arrayOf(PropTypes.string).isRequired,
  data: PropTypes.shape(JourneyQuestionShape).isRequired,
  exportEndpoint: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired
}

function mapStateToProps(state) {
  return {
    filterState: state.filters
  }
}

export default compose(translate(), connect(mapStateToProps))(Journeys)



// WEBPACK FOOTER //
// ./src/components/widgets/Journeys.jsx